<template lang="pug">
    div
        Row(type="flex" justify="space-between")
            Col(:lg="2" :md="4" :sm="24" v-if="$store.getters.getDashboardConfig.dashboardWithSearchBtn")
                SearchChartBtn(searchBtnText="GO" searchBtnIcon="md-search")
            Col(:lg="22" :md="20" :sm="24")
                components(
                :is="dashboardQueryFilterStyle[$store.getters.getDashboardConfig.dashboardQueryFilter]"
                :isWithGroupName="true"
                :isWithServiceGroupName="false"
                :isWithAppProfileName="true"
                :isWithServerName="false"
                :isWithTags="true"
                :isWithOrigin="true"
                :isWithEdgeName="$store.getters.isAdmin"
                :dateRangeLimit="dateRangeLimit"
                :customTimeRangeOptions="timeRangeOptions"
                :isWithLatencyStatusName="true")

        Tabs(type="card" :animated="false" v-model="activeTab") 
            Tab-pane(label="Origin Latency" name="originLatency") 
                div(v-if="activeTab == 'originLatency'")
                    Row
                        Col(:lg="12" :md="24")
                            Card.dashBoardCard
                                LineChartWrapper(
                                :chartType="'originLatencyTcpLineChartByGroups'"
                                chartTitle="Group Origins Latency (ms)"
                                :withCard="false"
                                :linePointRadius="[4]"
                                :linePointHoverRadius="[8]"
                                :linePointBackgroundColor="['white']"
                                :linePointBorderWidth="[3]"
                                :lineBorderColors="colorScheme.colorSets.border"
                                :useBackendDatasetLabel="true"
                                :legendPosition="'right'"
                                :legendAlign="'start'"
                                :isPointStyle="$store.getters.getChartConfig.legendPointStyle")
                        Col(:lg="12" :md="24")
                            Card.dashBoardCard
                                LineChartWrapper(
                                :chartType="'originLatencyTcpLineChartByOrigins'"
                                chartTitle="Origins Latency (ms)"
                                :withCard="false"
                                :linePointRadius="[4]"
                                :linePointHoverRadius="[8]"
                                :linePointBackgroundColor="['white']"
                                :linePointBorderWidth="[3]"
                                :lineBorderColors="colorScheme.colorSets.border"
                                :useBackendDatasetLabel="true"
                                :legendPosition="'right'"
                                :legendAlign="'start'"
                                :isPointStyle="$store.getters.getChartConfig.legendPointStyle")
                    Row(type="flex" justify="center")
                        Divider Origins Status Preview
                        Col(span="24")
                            div(style="text-align: center")
                                p These are top 20 origin hosts ordered by latency, the percentage indicate latest 20 minutes latency trending
                                p Click the origin to view the trending detail
                        Col(span="24")
                            OriginLatencyTcpList.originLatencyTcpList(v-model="analyticOrigins")
                        
            Tab-pane(label="Http Health Status" name="httpHealthStatus") 
                div(v-if="activeTab == 'httpHealthStatus'")
                    Row
                        Col(:lg="12" :md="24" style="width:100%")
                            Card.dashBoardCard
                                LineChartWrapper(
                                :chartType="'originLatencyHttpLineChart'"
                                :chartTitle="'http Status Code'"
                                :withCard="false"
                                :linePointRadius="[4]"
                                :linePointHoverRadius="[8]"
                                :linePointBackgroundColor="['white']"
                                :linePointBorderWidth="[3]"
                                :lineBorderColors="colorScheme.colorSets.border"
                                :useBackendDatasetLabel="true"
                                :legendPosition="'right'"
                                :legendAlign="'start'"
                                :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                                :healthCheckMode="['http']")
                    Row
                        Divider Http Status Preview 
                    Row
                        Col(span="24")
                            div(style="text-align: center")
                                p These are top 20 origin hosts ordered by latency, the number indicate latest 20 minutes http health status count
                                p Click the origin to view the trending detail
                        Col(span="24")
                            OriginLatencyTcpList.originLatencyTcpList(v-model="analyticOrigins" :healthCheckMode="['http']")

        template(v-if="activeTab == 'originLatency'" v-for="(origin, index) in analyticOrigins")
            Row
                Col(:span="$store.getters.isAdmin ? 12 : 24")
                    Card.dashBoardCard
                        LineChartWrapper(
                          :key="`${origin.originHost}:${origin.originPort}`"
                          :chartType="'originLatencyTcpLineChartAverageEdge'"
                          :chartTitle="`${origin.originHost}:${origin.originPort}`"
                          :originHosts="[origin.originHost]"
                          :originPorts="[origin.originPort]"
                          :withCard="true"
                          :linePointRadius="[4]"
                          :linePointHoverRadius="[8]"
                          :linePointBackgroundColor="['white']"
                          :linePointBorderWidth="[3]"
                          :lineBorderColors="colorScheme.colorSets.border"
                          :useBackendDatasetLabel="true"
                          :legendPosition="'right'"
                          :legendAlign="'start'"
                          :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                    )
                Col(span="12" v-if="$store.getters.isAdmin")
                    Card.dashBoardCard
                        LineChartWrapper(
                           :key="`${origin.originHost}:${origin.originPort}`"
                           :chartType="'originLatencyTcpLineChart'"
                           :chartTitle="`${origin.originHost}:${origin.originPort} By Edges`"
                           :originHosts="[origin.originHost]"
                           :originPorts="[origin.originPort]"
                           :withCard="false"
                           :linePointRadius="[4]"
                           :linePointHoverRadius="[8]"
                           :linePointBackgroundColor="['white']"
                           :linePointBorderWidth="[3]"
                           :lineBorderColors="colorScheme.colorSets.border"
                           :useBackendDatasetLabel="true"
                           :legendPosition="'right'"
                           :legendAlign="'start'"
                           :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                     )
                     
        template(v-if="activeTab == 'httpHealthStatus'" v-for="(origin, index) in analyticOrigins")
            Row
                Col(span="24")
                    Card.dashBoardCard
                        LineChartWrapper(
                           :key="`${origin.originHost}:${origin.originPort}`"
                           :chartType="'originLatencyHttpLineChart'"
                           :chartTitle="`${origin.originHost}:${origin.originPort} http code`"
                           :originHosts="[origin.originHost]"
                           :originPorts="[origin.originPort]"
                           :withCard="false"
                           :linePointRadius="[4]"
                           :linePointHoverRadius="[8]"
                           :linePointBackgroundColor="['white']"
                           :linePointBorderWidth="[3]"
                           :lineBorderColors="colorScheme.colorSets.border"
                           :useBackendDatasetLabel="true"
                           :legendPosition="'right'"
                           :legendAlign="'start'"
                           :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                           :healthCheckMode="['http']"
                     )
    
</template>
<script>
import bus from "@/libs/bus.js";
import store from "@/store";
import { getTimeRangeOptions } from "@/libs/utils";

import OriginLatencyTcpList from "@/components/dashboard/OriginLatencyTcpList";
import LineChartWrapper from "@/components/dashboard/LineChartWrapper";

import colorScheme from "@/data/colorScheme";

import DashboardQueryFilterV2 from "@/components/DashboardQueryFilterV2";
import DashboardQueryFilterV3 from "@/components/DashboardQueryFilterV3";
import enumList from "@/libs/enumList";

export default {
    name: "OriginLatency",
    components: {
        OriginLatencyTcpList,
        LineChartWrapper,
        SearchChartBtn: () => import("@/components/SearchChartBtn")
    },
    data() {
        return {
            analyticOrigins: [],
            colorScheme: colorScheme,
            chartHeight: 340,
            dashboardQueryFilterStyle: {
                V2: DashboardQueryFilterV2,
                V3: DashboardQueryFilterV3
            },
            activeTab: "originLatency",
            dateRangeLimit: 90,
            timeRangeOptions: [],
        };
    },
    methods: {
        async loadTimeSettings() {
            const { dateRangeLimit, timeRangeOptions } = await getTimeRangeOptions({
                dateRangeKey: enumList.dashboardTimeRangeType.REQUEST_SUMMARY,
            });
            this.dateRangeLimit = dateRangeLimit;
            this.timeRangeOptions = timeRangeOptions;
        },
    },
    mounted() {},
    computed: {},
    created() {
        this.loadTimeSettings();
    },
};
</script>

<style scoped>
.originLatencyTcpList {
    text-align: center;
    height: 250px;
    margin: 6px 6px 0px 6px;
    overflow-y: scroll;
}

.ivu-tabs.ivu-tabs-card > .ivu-tabs-tab {
    font-size: 18px;
    font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/view/dashboard/OriginLatency.vue